<div class="filter_btn">
    <div *ngIf="false">{{activeFiltersCount}}</div>
    <button type="button" (click)="toggleFilter()" [ngClass]="{'color_violet': activeFilter | async}" class="btn_filter color_text_gray"><span class="material-symbols-outlined fz_title">
        filter_alt
    </span></button>
</div>